import angular from 'angular';
import {
  ssDialogService,
} from 'app/services';
import editFacilitiesDialog from './dialog.editFacilitiesDialog';
import controller from './facilities.controller';
import directive from './facilities.directive';


export default angular.module('app.components.advisory.bcp.facilities', [
  ssDialogService,
  editFacilitiesDialog,
])
  .directive('bcpFacilities', directive)
  .controller('FacilitiesController', controller)
  .name;

console.log('app.components.advisory.bcp.facilities created');
